import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '新規会員申し込み',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
};
